import classNames from "classnames";
import React, { ReactNode } from "react";

export const SelectionWrapper = ({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) => {
  return (
    <div
      className={classNames(
        "gg-flex gg-w-full gg-flex-wrap gg-items-start gg-justify-start gg-gap-6 gg-pb-1",
        className,
      )}
    >
      {children}
    </div>
  );
};
